module.exports = __webpack_public_path__ + "img/17-6-15.ba459d0b.jpg";